/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Lv Zhuolin
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: Lv Zhuolin
 * @Description:
 * @FilePath: /desktop/src/store/modules/newlyMarried.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
    getNewlyMarriedData,
    AgreeNewlyMarried,
    rejectNewlyMarried,
    getNewlyMarriedInfo,
    downloadNewlyMarried
  } from "@/service/newlyMarriedService";
  const newlyMarried = {
    state: {},
    mutations: {},
    getters: {},
    actions: {
      /**
       * 获取新婚列表
       */
       getNewlyMarriedData(store, info) {
        return new Promise((resolve, reject) => {
          getNewlyMarriedData(info)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      /**
       * 获取新婚详情
       * @param {*} store
       * @param {*} id
       */
       getNewlyMarriedInfo(store, id) {
        return new Promise((resolve, reject) => {
            getNewlyMarriedInfo(id)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      /**
       * 同意审批
       * @param {*} store
       * @param {*} data
       */
       AgreeNewlyMarried(store, data) {
        return new Promise((resolve, reject) => {
            AgreeNewlyMarried(data)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      /**
       * 拒绝审批
       * @param {*} store
       * @param {*} data
       */
       rejectNewlyMarried(store, data) {
        return new Promise((resolve, reject) => {
            rejectNewlyMarried(data)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      /**
       * 下载zip
       * @param {*} store
       * @param {*} id
       */
       downloadNewlyMarried(store, id) {
        return new Promise((resolve, reject) => {
            downloadNewlyMarried(id)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        });
      }
    }
  };
  export default newlyMarried;
  


// WEBPACK FOOTER //
// ./src/store/modules/newlyMarried.js